"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_TYPE = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next13_components_text_1 = __importStar(require("@gerenciatd/next13.components.text"));
const enums_1 = require("./enums");
Object.defineProperty(exports, "LABEL_TYPE", { enumerable: true, get: function () { return enums_1.LABEL_TYPE; } });
const labelThemes = {
    promo: { color: next13_components_text_1.TEXT_COLOR.PURPLE, background: next13_components_text_1.TEXT_COLOR.PURPLE },
    active: { color: next13_components_text_1.TEXT_COLOR.BLUE, background: next13_components_text_1.TEXT_COLOR.BLUE },
    inactive: { color: next13_components_text_1.TEXT_COLOR.GREY4, background: next13_components_text_1.TEXT_COLOR.GREY4 },
    success: { color: next13_components_text_1.TEXT_COLOR.GREEN, background: next13_components_text_1.TEXT_COLOR.GREEN },
    warning: { color: next13_components_text_1.TEXT_COLOR.ORANGE, background: next13_components_text_1.TEXT_COLOR.ORANGE },
    error: { color: next13_components_text_1.TEXT_COLOR.RED, background: next13_components_text_1.TEXT_COLOR.RED },
    discount: { color: next13_components_text_1.TEXT_COLOR.WHITE, background: next13_components_text_1.TEXT_COLOR.RED_DARK },
    gift: { color: next13_components_text_1.TEXT_COLOR.WHITE, background: next13_components_text_1.TEXT_COLOR.BLUE_DARK },
    spent: { color: next13_components_text_1.TEXT_COLOR.WHITE, background: next13_components_text_1.TEXT_COLOR.GREY4 }
};
/**
 * @name Label
 * @description atomic component
 * @see {@link https://bit.cloud/gerenciatd/next13/components/label}
 * @param {any} props
 * @returns {React.FC}
 */
const Label = ({ theme, inversed, layout, notBorderRadius, label, customColors, className, custoObjectInfo, cyData }) => {
    var _a, _b;
    if (!label)
        return null;
    const { color: customColor = customColors === null || customColors === void 0 ? void 0 : customColors.color, background: customBackground = customColors === null || customColors === void 0 ? void 0 : customColors.background, } = customColors;
    const { color: themeColor = ((_a = labelThemes[theme]) === null || _a === void 0 ? void 0 : _a.color) || next13_components_text_1.TEXT_COLOR.PURPLE, background: themeBackground = ((_b = labelThemes[theme]) === null || _b === void 0 ? void 0 : _b.background) || next13_components_text_1.TEXT_COLOR.PURPLE, } = labelThemes[theme] || {};
    const labelColor = customColor || themeColor;
    const labelBg = inversed ? next13_components_text_1.TEXT_COLOR.WHITE : customBackground || themeBackground;
    return (react_1.default.createElement(next13_components_text_1.default, { text: label, color: labelColor, backgroundColor: labelBg, kind: next13_components_text_1.TEXT_KIND.SPAN, size: next13_components_text_1.TEXT_SIZE.CAPTION2, fontType: next13_components_text_1.TEXT_FONT_WEIGHT.REGULAR, align: next13_components_text_1.TEXT_ALIGN.CENTER, border: notBorderRadius ? next13_components_text_1.TEXT_BORDER.NONE : next13_components_text_1.TEXT_BORDER.ROUNDED, bgOpacity: notBorderRadius ? next13_components_text_1.TEXT_OPACITY[0] : next13_components_text_1.TEXT_OPACITY[10], className: `label ${className} label-theme--${theme || "custom"}${inversed ? "--inversed" : ""} layout--${layout} border-radius--${notBorderRadius} text-content`, custoObjectInfo: custoObjectInfo, cyData: cyData }));
};
Label.propTypes = {
    /**
     * Define el tema del label y puede ser uno de los siguientes valores: "promo", "active", "inactive", "success", "warning" o "error".
     */
    theme: prop_types_1.default.string,
    /**
     * Define el como se posiciona el label y puede ser uno de los siguientes valores: "default", "full" o "fantasy".
     */
    layout: prop_types_1.default.string,
    /**
     * Texto del label.
     */
    label: prop_types_1.default.string.isRequired,
    /**
     * Si es verdadero el fondo será blanco, pero manteniendo el color del texto del tema.
     */
    inversed: prop_types_1.default.bool,
    /**
     * Si es verdadero los bordes no son redondeados.
     */
    notBorderRadius: prop_types_1.default.bool,
    /**
     * Objeto que se utiliza para añadir colores personalizados al label. Debe tener dos propiedades opcionales:
     * - color: el color del texto personalizado.
     * - background: el color de fondo personalizado.
     */
    customColors: prop_types_1.default.shape({
        color: prop_types_1.default.string,
        background: prop_types_1.default.string,
    }),
    /**
     * Clase para añadirle estilos extras al icono.
     */
    className: prop_types_1.default.string,
    /**
     * Objeto para la customización del icono en dev.
     */
    custoObjectInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    }),
    cyData: prop_types_1.default.string,
};
Label.defaultProps = {
    theme: "",
    layout: "default",
    inversed: false,
    notBorderRadius: false,
    className: "",
    customColors: {},
    custoObjectInfo: null,
    cyData: ''
};
exports.default = Label;
//# sourceMappingURL=index.js.map